import dynamic from 'next/dynamic';

export const Divider = dynamic(
  () => import('antd/lib/divider'),
  { ssr: false },
);
